<!-- SCHEDULE NEW CONCLAVE - MODERN UI -->

<div class="min-h-screen bg-white px-4 py-6 md:px-8">

  <div class="mx-auto max-w-6xl">

    <!-- Header -->
    <div class="mb-2">
      <h1 class="text-xl font-semibold text-[#073B4C]">
        Schedule New Conclave
      </h1>


    </div>

    <form class="space-y-6" novalidate (ngSubmit)="onPublishConclave()">


      <!-- DETAILS -->
      <div class="rounded-3xl bg-white p-6 shadow-sm">

        <!-- Section Title -->
        <div class="mb-6 border-b border-slate-200 pb-4">
          <h2 class="text-md font-semibold text-[#073B4C]">
            Details
          </h2>
        </div>

        <!-- Fields -->
        <div class="grid gap-5 md:grid-cols-3">

          <!-- Title -->
          <div class="md:col-span-3">
            <label class="mb-2 block text-sm font-medium text-slate-700 req">
              Title
            </label>

            <input type="text" placeholder="Enter conclave title" required minlength="2"
              [(ngModel)]="title" name="title" (ngModelChange)="onValidatedFieldChange('title')"
              [class.border-red-500]="isSubmitted && formErrors['title']"
              class="h-12 w-full rounded-2xl border border-slate-300 bg-white px-4 text-sm outline-none transition focus:border-[#073B4C] focus:ring-4 focus:ring-[#073B4C]/10" />

            @if (isSubmitted && formErrors['title']) {
            @if (hasFieldError('title', 'required')) {
            <span class="mt-1 block text-xs text-red-500">Title is required</span>
            } @else if (hasFieldError('title', 'noSpaces')) {
            <span class="mt-1 block text-xs text-red-500">Title must not contain only spaces</span>
            } @else if (hasFieldError('title', 'trim')) {
            <span class="mt-1 block text-xs text-red-500">Trim leading and trailing spaces</span>
            } @else if (hasFieldError('title', 'minlength')) {
            <span class="mt-1 block text-xs text-red-500">Title must contain atleast 2 characters</span>
            } @else if (hasFieldError('title', 'maxlength')) {
            <span class="mt-1 block text-xs text-red-500">Title must not exceed more than 100 characters</span>
            } @else if (hasFieldError('title', 'pattern')) {
            <span class="mt-1 block text-xs text-red-500">Only alphabets, numbers, spaces, hyphen, period, and
              ampersand are allowed</span>
            }
            }
          </div>



          <!-- Description -->
          <div class="md:col-span-3">
            <label class="mb-2 block text-sm font-medium text-slate-700 req">
              Description
            </label>


            <textarea rows="5" placeholder="Write short description..." required minlength="10"
              [(ngModel)]="description" name="description" (ngModelChange)="onValidatedFieldChange('description')"
              [class.border-red-500]="isSubmitted && formErrors['description']"
              class="w-full rounded-2xl border border-slate-300 bg-white px-4 py-3 text-sm outline-none transition focus:border-[#073B4C] focus:ring-4 focus:ring-[#073B4C]/10"></textarea>
            @if (isSubmitted && formErrors['description']) {
            @if (hasFieldError('description', 'required')) {
            <span class="mt-1 block text-xs text-red-500">Description is required</span>
            } @else if (hasFieldError('description', 'noSpaces')) {
            <span class="mt-1 block text-xs text-red-500">Description must not contain only spaces</span>
            } @else if (hasFieldError('description', 'trim')) {
            <span class="mt-1 block text-xs text-red-500">Trim leading and trailing spaces</span>
            } @else if (hasFieldError('description', 'minlength')) {
            <span class="mt-1 block text-xs text-red-500">Description must contain atlest 10 characters</span>
            } @else if (hasFieldError('description', 'maxlength')) {
            <span class="mt-1 block text-xs text-red-500">Description must not exceed more than 1000 characters</span>
            } @else if (hasFieldError('description', 'pattern')) {
            <span class="mt-1 block text-xs text-red-500">Only alphabets, numbers, spaces, and common punctuation are
              allowed: , . : ; ! ? ( ) - / &</span>
            }
            }

          </div>


          <!-- Venue -->
          <div>
            <label class="mb-2 block text-sm font-medium text-slate-700 req">
              Venue
            </label>

            <input type="text" placeholder="Venue" [(ngModel)]="venue" name="venue"
              (ngModelChange)="onValidatedFieldChange('venue')"
              [class.border-red-500]="isSubmitted && formErrors['venue']"
              class="h-12 w-full rounded-2xl border border-slate-300 px-4 text-sm outline-none transition focus:border-[#073B4C] focus:ring-4 focus:ring-[#073B4C]/10" />
            @if (isSubmitted && formErrors['venue']) {
            @if (hasFieldError('venue', 'required')) {
            <span class="mt-1 block text-xs text-red-500">Venue is required</span>
            } @else if (hasFieldError('venue', 'noSpaces')) {
            <span class="mt-1 block text-xs text-red-500">Venue must not contain only spaces</span>
            } @else if (hasFieldError('venue', 'trim')) {
            <span class="mt-1 block text-xs text-red-500">Trim leading and trailing spaces</span>
            } @else if (hasFieldError('venue', 'minlength')) {
            <span class="mt-1 block text-xs text-red-500">Venue must contain atlest 5 characters</span>
            } @else if (hasFieldError('venue', 'maxlength')) {
            <span class="mt-1 block text-xs text-red-500">Venue must not exceed more than 255 characters</span>
            } @else if (hasFieldError('venue', 'pattern')) {
            <span class="mt-1 block text-xs text-red-500">Only alphabets, numbers, spaces, comma, period, hyphen,
              slash, and hash are allowed</span>
            }
            }

          </div>


          <!-- City -->
          <div>
            <label class="mb-2 block text-sm font-medium text-slate-700 req">
              City
            </label>

            <input type="text" placeholder="City" [(ngModel)]="city" name="city"
              (ngModelChange)="onValidatedFieldChange('city')"
              [class.border-red-500]="isSubmitted && formErrors['city']"
              class="h-12 w-full rounded-2xl border border-slate-300 px-4 text-sm outline-none transition focus:border-[#073B4C] focus:ring-4 focus:ring-[#073B4C]/10" />
            @if (isSubmitted && formErrors['city']) {
            @if (hasFieldError('city', 'required')) {
            <span class="mt-1 block text-xs text-red-500">City is required</span>
            } @else if (hasFieldError('city', 'noSpaces')) {
            <span class="mt-1 block text-xs text-red-500">City must not contain only spaces</span>
            } @else if (hasFieldError('city', 'trim')) {
            <span class="mt-1 block text-xs text-red-500">Trim leading and trailing spaces</span>
            } @else if (hasFieldError('city', 'minlength')) {
            <span class="mt-1 block text-xs text-red-500">City must contain 2 characters</span>
            } @else if (hasFieldError('city', 'maxlength')) {
            <span class="mt-1 block text-xs text-red-500">City must not exceed more than 50 characters</span>
            } @else if (hasFieldError('city', 'pattern')) {
            <span class="mt-1 block text-xs text-red-500">Only alphabets and spaces are allowed</span>
            }
            }

          </div>


          <!-- State -->
          <div>
            <label class="mb-2 block text-sm font-medium text-slate-700 req">
              State
            </label>

            <input type="text" placeholder="State" [(ngModel)]="state" name="state"
              (ngModelChange)="onValidatedFieldChange('state')"
              [class.border-red-500]="isSubmitted && formErrors['state']"
              class="h-12 w-full rounded-2xl border border-slate-300 px-4 text-sm outline-none transition focus:border-[#073B4C] focus:ring-4 focus:ring-[#073B4C]/10" />
            @if (isSubmitted && formErrors['state']) {
            @if (hasFieldError('state', 'required')) {
            <span class="mt-1 block text-xs text-red-500">State is required</span>
            } @else if (hasFieldError('state', 'noSpaces')) {
            <span class="mt-1 block text-xs text-red-500">State must not contain only spaces</span>
            } @else if (hasFieldError('state', 'trim')) {
            <span class="mt-1 block text-xs text-red-500">Trim leading and trailing spaces</span>
            } @else if (hasFieldError('state', 'minlength')) {
            <span class="mt-1 block text-xs text-red-500">State must contain at least 2 characters</span>
            } @else if (hasFieldError('state', 'maxlength')) {
            <span class="mt-1 block text-xs text-red-500">State must not exceed more than 50 characters</span>
            } @else if (hasFieldError('state', 'pattern')) {
            <span class="mt-1 block text-xs text-red-500">Only alphabets and spaces are allowed</span>
            }
            }

          </div>


        </div>
      </div>

      <!-- SCHEDULE -->
      <div class="rounded-3xl bg-white p-6 shadow-sm">

        <div class="mb-6 border-b border-slate-200 pb-4">
          <h2 class="text-md font-semibold text-[#073B4C]">
            Schedule
          </h2>
        </div>

        <div class="grid gap-5 md:grid-cols-3">

          <!-- No of Days -->
          <div>
            <label class="mb-2 block text-sm font-medium text-slate-700 req">
              No. of Days
            </label>

            <input type="number" [(ngModel)]="no_of_days" name="no_of_days" min="1" readonly
              placeholder="Enter number of days" [class.border-red-500]="isSubmitted && formErrors['no_of_days']"
              class="h-12 w-full rounded-2xl border border-slate-300 bg-slate-50 px-4 text-sm outline-none transition focus:border-[#073B4C] focus:ring-4 focus:ring-[#073B4C]/10" />

            <p *ngIf="isSubmitted && formErrors['no_of_days']" class="mt-1 text-sm text-red-600">
              {{ formErrors['no_of_days'] }}
            </p>
          </div>

          <!-- Start Date -->
          <div>
            <label class="mb-2 block text-sm font-medium text-slate-700 req">
              Start Date
            </label>

            <input type="date" [(ngModel)]="start_date" (ngModelChange)="onStartDateChange()" name="start_date"
              [class.border-red-500]="isSubmitted && formErrors['start_date']"
              class="h-12 w-full rounded-2xl border border-slate-300 px-4 text-sm outline-none transition focus:border-[#073B4C] focus:ring-4 focus:ring-[#073B4C]/10" />

            <p *ngIf="isSubmitted && formErrors['start_date']" class="mt-1 text-sm text-red-600">
              {{ formErrors['start_date'] }}
            </p>
          </div>

          <!-- Start Time -->
          <div>
            <label class="mb-2 block text-sm font-medium text-slate-700 req">
              Start Time
            </label>

            <input type="time" [(ngModel)]="start_time" (ngModelChange)="onStartTimeChange()" name="start_time"
              [class.border-red-500]="isSubmitted && formErrors['start_time']"
              class="h-12 w-full rounded-2xl border border-slate-300 px-4 text-sm outline-none transition focus:border-[#073B4C] focus:ring-4 focus:ring-[#073B4C]/10" />

            <p *ngIf="isSubmitted && formErrors['start_time']" class="mt-1 text-sm text-red-600">
              {{ formErrors['start_time'] }}
            </p>
          </div>

          <!-- End Date (force 2nd column) -->
          <div class="md:col-start-2">
            <label class="mb-2 block text-sm font-medium text-slate-700 req">
              End Date
            </label>

            <input type="date" [(ngModel)]="end_date" (ngModelChange)="onEndDateChange()" name="end_date"
              [class.border-red-500]="isSubmitted && formErrors['end_date']"
              class="h-12 w-full rounded-2xl border border-slate-300 px-4 text-sm outline-none transition focus:border-[#073B4C] focus:ring-4 focus:ring-[#073B4C]/10" />

            <p *ngIf="isSubmitted && formErrors['end_date']" class="mt-1 text-sm text-red-600">
              {{ formErrors['end_date'] }}
            </p>
          </div>

          <!-- End Time (force 3rd column) -->
          <div class="md:col-start-3">
            <label class="mb-2 block text-sm font-medium text-slate-700 req">
              End Time
            </label>

            <input type="time" [(ngModel)]="end_time" (ngModelChange)="onEndTimeChange()" name="end_time"
              [class.border-red-500]="isSubmitted && formErrors['end_time']"
              class="h-12 w-full rounded-2xl border border-slate-300 px-4 text-sm outline-none transition focus:border-[#073B4C] focus:ring-4 focus:ring-[#073B4C]/10" />

            <p *ngIf="isSubmitted && formErrors['end_time']" class="mt-1 text-sm text-red-600">
              {{ formErrors['end_time'] }}
            </p>
          </div>

        </div>
      </div>

      <!-- TICKET -->
      <div class="rounded-3xl bg-white p-6 shadow-sm">

        <div class="mb-6 border-b border-slate-200 pb-4">
          <h2 class="text-md font-semibold text-[#073B4C]">
            Ticket Pricing
          </h2>
        </div>

        <div class="space-y-5">

          <!-- Radio -->
          <div class="flex flex-wrap items-center gap-8">


            <label class="flex items-center gap-3">
              <input type="radio" name="ticket_type" [(ngModel)]="ticket_type" value="Free"
                (ngModelChange)="ticket_type === 'Free' && (price_per_head = null)" class="h-4 w-4 accent-[#073B4C]" />

              <span class="text-sm font-medium text-slate-700">
                Free
              </span>
            </label>

            <label class="flex items-center gap-3">
              <input type="radio" name="ticket_type" [(ngModel)]="ticket_type" value="Paid"
                class="h-4 w-4 accent-[#073B4C]" />

              <span class="text-sm font-medium text-slate-700">
                Paid
              </span>
            </label>


          </div>

          <!-- Price -->
          <div class="max-w-sm">
            <label class="mb-2 block text-sm font-medium text-slate-700 req">
              Price per head
            </label>

            <input type="text" inputmode="numeric" placeholder="0" [(ngModel)]="price_per_head" name="price_per_head"
              maxlength="7" (input)="onPricePerHeadInput($event)" [disabled]="ticket_type === 'Free'"
              class="h-12 w-full rounded-2xl border border-slate-300 px-4 text-sm outline-none transition focus:border-[#073B4C] focus:ring-4 focus:ring-[#073B4C]/10 disabled:bg-slate-100 disabled:text-slate-500 disabled:cursor-not-allowed" />
            <p *ngIf="isSubmitted && formErrors['price_per_head']" class="mt-1 text-sm text-red-600">
              {{ formErrors['price_per_head'] }}
            </p>

          </div>

        </div>
      </div>

      <!-- PARTICIPANTS -->
      <div class="rounded-3xl bg-white p-6 shadow-sm">

        <div class="mb-6 border-b border-slate-200 pb-4">
          <h2 class="text-md font-semibold text-[#073B4C]">
            Participants
          </h2>
        </div>

        <div class="space-y-5">

          <!-- Radio -->
          <div class="flex flex-col gap-4 md:flex-row md:gap-10">

            <label class="flex items-center gap-3">
              <input type="radio" name="participant_type" [(ngModel)]="participant_type" value="Anyone"
                class="h-4 w-4 accent-[#073B4C]" />

              <span class="text-sm font-medium text-slate-700">
                Anyone on Teacherfactory
              </span>
            </label>

            <label class="flex items-center gap-3">
              <input type="radio" name="participant_type" [(ngModel)]="participant_type" value="Group"
                class="h-4 w-4 accent-[#073B4C]" />

              <span class="text-sm font-medium text-slate-700">
                Only selected Groups
              </span>
            </label>


          </div>

          <!-- Groups -->
          <div class="relative" *ngIf="participant_type === 'Group'">
            <label class="mb-2 block text-sm font-medium text-slate-700">
              Select Groups
            </label>

            <p *ngIf="(isSubmitted || (participant_type === 'Group' && selected_groups.length === 0)) && formErrors['selected_groups']" class="mt-1 text-sm text-red-600">
              {{ formErrors['selected_groups'] }}
            </p>



            <!-- Trigger -->
            <button type="button"
              class="flex h-12 w-full items-center justify-between gap-3 rounded-2xl border border-slate-300 bg-white px-4 text-left text-sm outline-none transition focus:border-[#073B4C] focus:ring-4 focus:ring-[#073B4C]/10"
              data-groups-trigger
              (click)="groupsDropdownOpen = !groupsDropdownOpen;">
              <span class="truncate text-sm font-medium text-slate-700">
                <ng-container *ngIf="selected_groups.length === 0; else selectedGroupsSummary">
                  Select Groups
                </ng-container>
                <ng-template #selectedGroupsSummary>
                  {{ selected_groups.length }} Group{{ selected_groups.length === 1 ? '' : 's' }} selected
                </ng-template>
              </span>
              <span class="text-slate-500">▾</span>
            </button>

            <!-- Dropdown Panel -->
            <div *ngIf="groupsDropdownOpen" data-groups-panel
              class="absolute left-0 z-10 mt-2 w-full overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
              <div class="max-h-60 overflow-auto p-3">
                <label *ngFor="let g of groups"
                  class="flex cursor-pointer items-center gap-2 rounded-xl border border-transparent px-3 py-2 hover:border-slate-200 hover:bg-slate-50">
                  <input type="checkbox" [checked]="selected_groups.includes(g.id)" (change)="toggleSelectedGroup(g.id)"
                    class="h-4 w-4 accent-[#073B4C]" />
                  <span class="text-sm font-medium text-slate-700">{{ g.group_name }}</span>
                </label>

                <div *ngIf="groups.length === 0" class="p-3 text-sm text-slate-500">

                  No groups found.
                </div>
              </div>
            </div>
          </div>



        </div>
      </div>

      <!-- REGISTRATION -->
      <div class="rounded-3xl bg-white p-6 shadow-sm">

        <div class="mb-6 border-b border-slate-200 pb-4">
          <h2 class="text-md font-semibold text-[#073B4C]">
            Registration
          </h2>
        </div>

        <div class="grid gap-5 md:grid-cols-2">

          <!-- Link -->
          <div>
            <label class="mb-2 block text-sm font-medium text-slate-700 req">
              Registration Link
            </label>

<input type="text" placeholder="Enter registration link" [(ngModel)]="registerion_link"
              name="registerion_link" (ngModelChange)="onRegistrationLinkChange()"
              [class.border-red-500]="isSubmitted && formErrors['registerion_link']"
              class="h-12 w-full rounded-2xl border border-slate-300 px-4 text-sm outline-none transition focus:border-[#073B4C] focus:ring-4 focus:ring-[#073B4C]/10" />
            <p *ngIf="isSubmitted && formErrors['registerion_link']" class="mt-1 text-sm text-red-600">
              {{ formErrors['registerion_link'] }}
            </p>
          </div>



          <!-- Deadline -->
          <div>
            <label class="mb-2 block text-sm font-medium text-slate-700 req">
              Registration Deadline
            </label>

<input type="date" [(ngModel)]="registration_deadline_date" name="registration_deadline_date"
              (ngModelChange)="onRegistrationDeadlineChange()"
              [class.border-red-500]="isSubmitted && formErrors['registration_deadline_date']"
              class="h-12 w-full rounded-2xl border border-slate-300 px-4 text-sm outline-none transition focus:border-[#073B4C] focus:ring-4 focus:ring-[#073B4C]/10" />
            <p *ngIf="isSubmitted && formErrors['registration_deadline_date']" class="mt-1 text-sm text-red-600">
              {{ formErrors['registration_deadline_date'] }}
            </p>
          </div>



        </div>
      </div>

      <!-- COVER -->
      <div class="rounded-3xl bg-white p-6 shadow-sm">

        <div class="mb-6 border-b border-slate-200 pb-4">
          <h2 class="text-md font-semibold text-[#073B4C]">
            Cover Page
          </h2>
        </div>

        <!-- Upload / Preview -->
        <div>
          <ng-container *ngIf="coverImagePreviewUrl; else uploadUi">
            <div class="overflow-hidden rounded-3xl border border-slate-200 bg-white">
              <img [src]="coverImagePreviewUrl" alt="Cover Preview" class="h-[260px] w-full object-cover" />
            </div>

            <button type="button"
              class="mt-3 h-10 rounded-2xl border border-slate-300 bg-white px-4 text-sm font-medium text-slate-700 transition hover:border-[#073B4C] hover:text-[#073B4C]"
              (click)="selectedCoverFile=null; coverImagePreviewUrl=null; cover_image_url=''">
              Remove image
            </button>
          </ng-container>

          <ng-template #uploadUi>
            <label
              class="flex min-h-[260px] cursor-pointer flex-col items-center justify-center rounded-3xl border-2 border-dashed border-slate-300 bg-slate-50 transition hover:border-[#073B4C] hover:bg-[#073B4C]/5">
              <input type="file" class="hidden" accept="image/*" (change)="onCoverFileSelected($event)" />

              <div
                class="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-[#073B4C]/10 text-3xl text-[#073B4C]">
                ↑
              </div>

            <p class="text-base font-medium text-slate-700">
                Upload Cover Image
              </p>

              @if (coverValidationError) {
              <p class="mt-2 text-sm text-red-600">
                {{ coverValidationError }}
              </p>
              }


              <p class="mt-2 text-sm text-slate-500">
                Drag & Drop or Click to Upload
              </p>
            </label>
          </ng-template>
        </div>
      </div>

      <!-- BUTTONS -->
      <div class="flex flex-col-reverse gap-4 pb-10 sm:flex-row sm:justify-start">
        <button type="submit"
          [disabled]="isSubmitting || isPublishLocked"
          [class.opacity-60]="isSubmitting || isPublishLocked"
          [class.cursor-not-allowed]="isSubmitting || isPublishLocked"
          class="h-12 rounded-xl bg-[#073B4C] px-8 text-sm font-medium text-white shadow-sm transition hover:bg-[#052C38] disabled:hover:bg-[#073B4C] disabled:opacity-60">

          @if (isSubmitting || isPublishLocked) {
            <span class="inline-flex items-center gap-2">
              <svg class="h-4 w-4 animate-spin" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" stroke-opacity="0.25" />
                <path d="M22 12c0-5.523-4.477-10-10-10" stroke="currentColor" stroke-width="4" stroke-linecap="round" />
              </svg>
              Saving...
            </span>
          } @else {
            Save
          }
        </button>
        <button type="button"
          class="h-12 rounded-xl border border-[#073B4C] px-8 text-sm font-medium text-[#073B4C] transition hover:bg-[#073B4C]/5">

          Cancel
        </button>



      </div>

    </form>

  </div>

</div>
